<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle v-if="message">{{ message }}</v-card-subtitle>
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-select
          v-model="selectedValue"
          outlined
          dense
          :items="items"
          :hint="hint"
          :persistent-hint="!!hint"
          :hide-details="!hint"
          :placeholder="placeholder"
        ></v-select>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text :disabled="loading" @click="$emit('close')">Cancelar</v-btn>
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="!selectedValue"
        >Aceptar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class SelectModal extends Vue {
    @Prop() title: string;
    @Prop() message: string;
    @Prop() placeholder: string;
    @Prop() hint: string;
    @Prop() items: { value: string | number; text: string }[];
    selectedValue: string | number | null = null;
    loading = false;
    valid = false;

    async created() {}

    async submit() {
      this.loading = true;

      await (<Function>this.$parent.$listeners.submit)(this.selectedValue);

      this.loading = false;
    }
  }
</script>
